/**
 * @file newCollegeStudentDemographics.js
 * @author Jake Stark
 * @desc newStudentDemographics report plugin

*/

/**
 * @module newStudentDemographics 
 * @desc newStudentDemographics report plugin
 */

define('plugins/newCollegeStudentDemographics',["underscore",
        "cardboard/models", "cardboard/collections", "cardboard/util",
        "text!plugins/templates/newCollegeStudentDemographics_freshmanOrTransfer_table.html!strip", 
        "text!plugins/templates/newCollegeStudentDemographics_newEnrollmentByRace_table.html!strip", "text!plugins/templates/newCollegeStudentDemographics_newEnrollmentByAge_table.html!strip", "text!plugins/templates/newCollegeStudentDemographics_newEnrollmentByGender_table.html!strip", "text!plugins/templates/newCollegeStudentDemographics_newEnrollmentByResidency_table.html!strip", "text!plugins/templates/newCollegeStudentDemographics_topTen_table.html!strip", "text!plugins/templates/newCollegeStudentDemographics_topHS_table.html!strip", "models", "cardboard/pluginPieces"
    ],
    function (_,
        CardboardModels, CardboardCollections, Util,
        freshmanOrTransfer, newEnrollmentByRace, newEnrollmentByAge, newEnrollmentByGender, newEnrollmentByResidency, topTenTemplate, topHSTemplate, SLEDSModels, PluginPieces) {

        console.log("MODULE: newStudentDemographics");

        var exports = {

            // options for the demo cats config. since this is a multi-select
            // report, we have to use a different view object, and tell it not to
            // show grades as categories.
            options: {
                //    dynamicTextDomain: "newStudentDemographics",
                orgDetailPane: false,
                noMapSearch: true,
                forcedSummaryFilters: ["newCollegeStudentDemographicsCOHORTID"],
                // Show Filter definitions link at bottom of filter pane
                definitions: true
            },

            // each of these is the configuration that gets passed to a
            // DataBoxPaneView.
            panes: [{
                    title: "Freshmen or Transfer",
                    //titlePath: "collegeEnrollment.contents.0",
                    explanationText: "This report shows the number and percent of students entering college in fall term as freshmen students (first-time attending college after high school graduation at any institution) or transfer students (attended another postsecondary institution previously after high school graduation).",
                    //explanationTextPath: "collegeEnrollment.contents.1",
                    openByDefault: true,
                    views: [{
                            type: "template",
                            template: "<h5>Percent of new undergraduate students by registration type</h5>",
                            //      dataSourceName: "data",
                            //    dataSetPath: "dataSets.organizations",

                        },
                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "stackedColumn",
                            dataSourceName: "data",
                            dataPath: "freshmenOrTransfer.slices",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //	 +---------+
                            //	 | X X X X |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 +---------+
                            dataShape: "pointsWithinRows",
                            dataDimensions: 2,

                            // DISPLAY
                            // xAxisLabelPath: "subjects.label",
                            xAxisLabelPath: "orgName",
                            unitString: "%",
                            showLegend: true,
                            // yAxisMin: 1,
                            // yAxisMax: 50000,
                            // yAxisType: "logarithmic",

                            // SERIES
                            series: [{
                                seriesDisplayNamePath: "label",
                                dataPath: "organizations",
                                valuePath: "percent",

                            }],
                            errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: "Sorry, we don't have any data for your selected College and Year."
                                }
                            }]

                        },
                        {
                            type: "template",
                            template: freshmanOrTransfer,
                            dataSourceName: "data",
                            //  errorConditions: [PluginPieces.silentStandardErrorCondition]
                        }
                    ]
                },

                {
                    title: "New Enrollment by Race/Ethnicity",
                    explanationText: "This report shows the number and percent of new enrolling students by race/ethnicity. Prior to 2010, race/ethnicity data was collected using the 5 federal race categories. After 2010, race/ethnicity data was collected using the 9 federal race categories for college students. Please see race/ethnicity in the data dictionary for more information. “Unavailable” means the student did not report their race/ethnicity to the college.",
                    openByDefault: false,
                    views: [{
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "stackedColumn",
                            dataSourceName: "data",
                            dataPath: "newEnrollmentByRaceEthnicity.data[0].slice",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //	 +---------+
                            //	 | X X X X |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 +---------+
                            dataShape: "pointsWithinRows",
                            // convertDataHashToArray: true,
                            dataDimensions: 2,
                            xAxisLabelPath: "orgName",

                            // DISPLAY
                            unitString: "%",
                            showLegend: true,
                            // tooltipTemplate: "REPLACE",
                            //      dataLabels: false,

                            series: [{
                                seriesDisplayNamePath: "name",
                                dataPath: "values",
                                valuePath: "percent",
                                //  colors: ["grey", "magenta", "yellow", "red", "green", "purple", "orange", "blue1", "blue3"]
                            }],

                            errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: "Sorry, we don't have any data for your selected College and Year."
                                }
                            }]
                        },
                        {
                            type: "template",
                            template: newEnrollmentByRace,
                            dataSourceName: "data",
                            //errorConditions: [PluginPieces.silentStandardErrorCondition]
                        }
                    ]
                },
                {
                    title: "New Enrollment by Gender",
                    explanationText: "This report shows the number and percent of new enrolling students by gender. Beginning with fall 2021-22 data, the Office of Higher Education collects a designation of the student's sex (shown here as gender) as M (male), F (female), or X (another option not listed). Unknown means the student reported another option not listed, did not report their sex to the college, or the college did not report this data to the state. ",
                    openByDefault: false,
                    views: [{
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "stackedColumn",
                            dataSourceName: "data",
                            dataPath: "newEnrollmentByGender.data",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //	 +---------+
                            //	 | X X X X |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 +---------+
                            dataShape: "pointsAcrossRows",
                            convertDataHashToArray: true,
                            dataDimensions: 2,
                            xAxisLabelPath: "orgName",

                            // DISPLAY
                            unitString: "%",
                            showLegend: true,
                            //  tooltipTemplate: "REPLACE",
                            dataLabels: false,

                            // SERIES
                            series: [

                                {
                                    seriesDisplayNamePath: "[0].slice[0].name",
                                    valuePath: "slice[0].percent",

                                },
                                {
                                    seriesDisplayNamePath: "[0].slice[1].name",
                                    valuePath: "slice[1].percent",

                                },
                                {
                                    seriesDisplayNamePath: "[0].slice[2].name",
                                    valuePath: "slice[2].percent",

                                }
                            ],
                            errorConditions: [{
                                valuePath: "data.data[0]",
                                is: undefined,
                                error: {
                                    type: "NoData",
                                    message: "Sorry, we don't have any data for your selected College and Year."
                                }
                            }]
                        },
                        {
                            type: "template",
                            template: newEnrollmentByGender,
                            dataSourceName: "data",
                            //    errorConditions: [PluginPieces.silentStandardErrorCondition]
                        }
                    ]
                },
                {
                    title: "New Enrollment by Age",
                    explanationText: "This report shows the number and percent of new enrolling students by age at time of enrollment in the year selected. “Unknown” means the student did not report their date of birth to the college.",
                    openByDefault: false,
                    views: [{
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "stackedColumn",
                            dataSourceName: "data",
                            dataPath: "newEnrollmentByAge.data",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //	 +---------+
                            //	 | X X X X |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 +---------+
                            dataShape: "pointsAcrossRows",
                            convertDataHashToArray: true,
                            dataDimensions: 2,
                            xAxisLabelPath: "orgName",

                            // DISPLAY
                            unitString: "%",
                            showLegend: true,
                            //    tooltipTemplate: "REPLACE",
                            dataLabels: false,

                            // SERIES
                            series: [{
                                    seriesDisplayNamePath: "[0].slice[0].name",
                                    valuePath: "slice[0].percent",

                                },
                                {
                                    seriesDisplayNamePath: "[0].slice[1].name",
                                    valuePath: "slice[1].percent",

                                },
                                {
                                    seriesDisplayNamePath: "[0].slice[2].name",
                                    valuePath: "slice[2].percent",

                                },
                                {
                                    seriesDisplayNamePath: "[0].slice[3].name",
                                    valuePath: "slice[3].percent",

                                },
                                {
                                    seriesDisplayNamePath: "[0].slice[4].name",
                                    valuePath: "slice[4].percent",

                                }
                            ],
                            errorConditions: [{
                                valuePath: "data.data[0]",
                                is: undefined,
                                error: {
                                    type: "NoData",
                                    message: "Sorry, we don't have any data for your selected College and Year."
                                }
                            }]
                        },
                        {
                            type: "template",
                            template: newEnrollmentByAge,
                            dataSourceName: "data",
                            //errorConditions: [PluginPieces.silentStandardErrorCondition]
                        }
                    ]
                },
                {
                    title: "New Enrollment by State of Residence",
                    explanationText: "This report shows the number and percent of new enrolling students by state of permanent residence at time of enrollment in the year selected. ",
                    openByDefault: false,
                    views: [{
                            // SETUP
                            type: "pie",
                            dataSourceName: "data",
                            dataSetPath: "newEnrollmentByResidency",
                            //dataPath: "dataSets.raceAndEthnicity.data", 
                            // all paths in the
                            // chartable series are
                            // relative to this blob

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //	 +---------+
                            //	 | X X X X |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 +---------+
                            dataShape: "pointsWithinRows",

                            // since in this case there's only one dimension, due to
                            // there being only one series to plot, it looks like
                            // this:
                            //	 +---------+
                            //	 | X X X X |
                            //	 +---------+
                            convertDataHashToArray: true,
                            dataDimensions: 1,
                            title: "",

                            // DISPLAY
                            unitString: "%",
                            unitDec: 0,

                            showLegend: true,
                            dataLabels: false,

                            // SERIES (only one series, this is a simple graph)
                            series: [{
                                valuePath: "percent",
                                displayNamePath: "residencyName",
                                longDisplayNamePath: "residencyName",
                            }],
                            errorConditions: [{
                                valuePath: "data.data[0]",
                                is: undefined,
                                error: {
                                    type: "NoData",
                                    message: "Sorry, we don't have any data for your selected College and Year."
                                }
                            }]

                        },
                        {
                            type: "template",
                            template: newEnrollmentByResidency,
                            dataSourceName: "data",
                            //errorConditions: [PluginPieces.silentStandardErrorCondition]
                        }
                    ]
                },

                {
                    title: "Top Ten Minnesota Counties",
                    explanationText: "This report shows the number and percent of new enrolling students by county of permanent residence, if the student was a Minnesota resident at time of enrollment.",

                    openByDefault: false,
                    views: [{
                        type: "template",
                        template: topTenTemplate,
                        dataSourceName: "data",
                        errorConditions: [{
                            valuePath: "data.data.topTenCounties.counties[0]",
                            is: undefined,
                            error: {
                                type: "NoData",
                                message: "Sorry, we don't have any data for your selected College and Year."
                            }
                        }]
                    }]
                },
                {
                    title: "New Enrollment by High School",
                    explanationText: "This report shows the number of new enrolling students by high school of graduation in descending order, if the student was a Minnesota resident at time of enrollment. Only the top 25 high schools are shown.",

                    openByDefault: false,
                    views: [{
                        type: "template",
                        template: topHSTemplate,
                        dataSourceName: "data",
                        errorConditions: [{
                            valuePath: "data.data.topHighSchools.highSchools[0]",
                            is: undefined,
                            error: {
                                type: "NoData",
                                message: "Sorry, we don't have any data for your selected College and Year."
                            }
                        }]
                    }]
                },
                {
                    title: "More Information",
                    visibleByDefault: true,
                    openByDefault: false,
                    views: [{
                        type: "template",
                        template: "<p><a href='' data-role='button' class='ui-link ui-btn ui-shadow ui-corner-all' role='button'>Download All Data</a></p><p>For more information on college enrollment data, please visit the  <a href='https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=059077&RevisionSelectionMethod=latestReleased&Rendition=primary'>Data Interpretation Guide</a> and the <a href='http://www.ohe.state.mn.us/mPg.cfm?pageID=740' target='_blank'>Office of Higher Education's Student Enrollment Data</a>.</p><p><a href='https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=mde031883&RevisionSelectionMethod=latestReleased&Rendition=primary'>Download web report data</a> for all colleges or systems and years. Please note this file does not include subgroup statistics. For more information, <a href='https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=mde031756&RevisionSelectionMethod=latestReleased&Rendition=primary'>read the help document</a>.</p>"
                    }]
                }
            ],

            filterSources: {
                orgs: {
                    modelType: SLEDSModels.SLEDSOrgList,
                    url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_ps_orgid.fex",
                    noViewParams: true,
                    enabled: true
                },
                filters: {
                    modelType: CardboardModels.FilterData,
                    url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_ecodevregion_college.fex",
                    enabled: true
                },
                filters2: {
                    url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_newcollegestudentdemographicscohortid.fex",
                    enabled: true,
                    modelType: CardboardModels.FilterData
                },
                demographicCategories: {
                    modelType: CardboardCollections.DemoCatProducer,
                    url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_newcollegeStudentDemographicsButtons.fex",
                    enabled: true,
                    noViewParams: false,
                    isCat: true
                }
            },
            dataSources: {
                data: {
                    modelType: CardboardModels.DocumentModel,
                    url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_newcollegestudentdemographics.fex",
                    yearPath: "dataYear",
                    defaultParams: {
                        orgId: 999999000,
                        newCollegeStudentDemographicsCOHORTID: 2016
                    },
                    paramMappings: {
                        newCollegeStudentDemographicsCOHORTID: "dataYear",
                        PS_ORGID: "orgId",
                        orgName: null // skip this
                    },
                    enabled: true,
                    errorConditions: [{
                        valuePath: "errorMessage",
                        isNot: null,
                        error: {
                            type: "NoData",
                            message: "Data is not available."
                        }
                    }]
                }
            }
        };

        return exports;
    });
